export default {"src":"/_next/static/media/shield.085167b6.svg","height":1200,"width":1200};